import { useContext, useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { FaUserLarge } from "react-icons/fa6";
import { FiImage } from "react-icons/fi";
import { IoTicketSharp } from "react-icons/io5";
import { RiEditCircleLine } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../../Context/AppContext";
import useAxiosInstance from "../../../Utilities/Hooks/useAxiosInstance";
import BackButton from "../../Partials/Elements/BackButton/BackButton";
import Modal from "../../Partials/Elements/Modal/Modal";
import ArchiveItem from "../../Partials/Layouts/ArchiveItem/ArchiveItem";
import CreateButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton";
import ArchiveButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ArchiveButton/ArchiveButton";
import CRUDButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/CRUDButton";
import EditButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton";
import CRUDTable from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable";
import ShortTextCell from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableHeader from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow";
import FilterSelect from "../../Partials/Layouts/Forms/FilterSelect/FilterSelect";
import CreateEvent from "./CreateEvent";
import UpdateEvent from "./UpdateEvent";
import UpdateStatus from "./UpdateStatus";
import ViewEvent from "./ViewEvent";
import EventOrderModal from "./EventOrderModal/EventOrderModal";

function Events() {

  const { status } = useParams()
  const [events, setEvents] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [targetID, setTargetID] = useState(null);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);
  const [showStatusSection, setShowStatusSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);
  const [showEventOrderModal, setShowEventOrderModal] = useState(false);

  const axiosInstance = useAxiosInstance();
  const [archive, setArchive] = useState(null);
  const [filter, setFilter] = useState("active");
  const { employee } = useContext(AppContext);
  const navigate = useNavigate()

  useEffect(() => {
    async function fetchAndSetEvents() {
      const { data } = await axiosInstance.get(`events?filter=${filter}&status=${status}`);
      setEvents(data);
    }
    fetchAndSetEvents();
  }, [toggleFetch, axiosInstance, filter, status]);

  function handleClose() {
    setShowModal(false);
    setShowCreateForm(false);
    setShowViewSection(false);
    setShowUpdateForm(false);
    setShowDeleteSection(false);
    setShowEventOrderModal(false);
    setTargetID(null);
  }

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }


  return (
    <>
      <div className="crud_holder">
        <div className="body_header">
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <BackButton />
            <h1 className="heading">{`${status === "nowSelling" && "Now Selling" || status === "upcoming" && "Upcoming" || status === "past" && "Past" || status === "voteToBring" && "Vote to Bring"} Events (${events?.length ? events?.length : 0} in total)`}</h1>
          </div>

          <FilterSelect filter={filter} setFilter={setFilter} />

          <CreateButton
            screenTopicSingular="Event"
            setShowModal={setShowModal}
            setShowCreateForm={setShowCreateForm}
          />
        </div>
        <CRUDTable>
          <CRUDTableHeader>
            <CRUDth th="Name" />

            <CRUDth th="Organizer" />
            <CRUDth th="Type" />
            <CRUDth th="Actions" />
          </CRUDTableHeader>
          <tbody>
            {events?.map((event) => (
              <CRUDTableRow key={event._id} onClick={() => {
                setShowModal(true)
                setShowViewSection(true)
                setTargetID(event._id)
              }}>
                <ShortTextCell text={event.name} />

                <ShortTextCell text={event.organizer} />
                <ShortTextCell text={event.type} />

                <td className="action_button_cell">
                  {
                    employee.level === "producer" ?
                      <CRUDButton
                        dataTip="Event Orders"
                        dataFor="Manage Event Orders"
                        handleClick={(e) => {
                          e.stopPropagation()
                          setTargetID(event._id)
                          setShowModal(true)
                          setShowEventOrderModal(true)
                        }}
                      >
                        <IoTicketSharp />
                      </CRUDButton> :
                      <>
                        <CRUDButton
                          dataTip="Event Orders"
                          dataFor="Manage Event Orders"
                          handleClick={(e) => {
                            e.stopPropagation()
                            setTargetID(event._id)
                            setShowModal(true)
                            setShowEventOrderModal(true)
                          }}
                        >
                          <IoTicketSharp />
                        </CRUDButton>
                        <CRUDButton
                          dataTip=" Event Producers"
                          dataFor="Manage Event Producers"
                          handleClick={(e) => {
                            e.stopPropagation()
                            navigate(`/event/producers/${event._id}/${event.name}`);
                          }}
                        >
                          <FaUser />
                        </CRUDButton>
                        <EditButton
                          setShowModal={setShowModal}
                          setShowUpdateForm={setShowUpdateForm}
                          targetID={event._id}
                          setTargetID={setTargetID}
                        />

                        <ArchiveButton
                          setShowModal={setShowModal}
                          setShowDeleteSection={setShowDeleteSection}
                          targetID={event._id}
                          isArchive={event?.isArchive}
                          setTargetID={setTargetID}
                          setArchive={setArchive}
                        />

                        <CRUDButton
                          dataTip=" Event Manage"
                          dataFor=" Event Manage Item"
                          handleClick={(e) => {
                            e.stopPropagation()
                            navigate("/eventsScreens/" + event._id)

                          }
                          }
                        >
                          <FiImage />
                        </CRUDButton>

                        <CRUDButton
                          dataTip=" Status"
                          dataFor=" Status"
                          handleClick={() => {
                            setShowModal(true)
                            setShowStatusSection(true)
                            setTargetID(event._id)
                          }
                          }
                        >
                          <RiEditCircleLine />

                        </CRUDButton>
                        {
                          event?.status === "voteToBring" &&
                          <CRUDButton
                            dataTip="Voted User"
                            dataFor="Voted"
                            handleClick={() =>
                              navigate(`/event/upvoted/user/${event?.name}/${event?._id}`)
                            }

                          >
                            <FaUserLarge />
                          </CRUDButton>
                        }
                      </>
                  }
                </td>
              </CRUDTableRow>
            ))}
          </tbody>
        </CRUDTable>
      </div>
      {showModal && (
        <Modal
          handleClose={handleClose}
          modalHeading={
            (showCreateForm && `Create Event`) ||
            (showUpdateForm && `Update Event`) ||
            (showDeleteSection && `Archive Event`) ||
            (showStatusSection && `Update Status`) ||
            (showEventOrderModal && `Event Orders`)

          }
        >
          {showCreateForm && (
            <CreateEvent
              employee={employee}
              setShowCreateForm={setShowCreateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
              status={status}
            />
          )}
          {showUpdateForm && (
            <UpdateEvent
              employee={employee}
              targetID={targetID}
              setShowUpdateForm={setShowUpdateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
            />
          )}
          {showDeleteSection && (
            <ArchiveItem
              api={"events/archiveEvent/"}
              targetID={targetID}
              setShowModal={setShowModal}
              setShowDeleteSection={setShowDeleteSection}
              triggerFetch={triggerFetch}
              isArchive={archive}
            />
          )}

          {showStatusSection && (
            <UpdateStatus
              targetID={targetID}
              setShowModal={setShowModal}
              setShowStatusSection={setShowStatusSection}
              triggerFetch={triggerFetch}
              isArchive={archive}
            />
          )}

          {showEventOrderModal && (
            <EventOrderModal
              targetID={targetID}
              setShowModal={setShowModal}
              setShowEventOrderModal={setShowEventOrderModal}
              triggerFetch={triggerFetch}
            />
          )}
        </Modal>
      )}

      {showModal && showViewSection && (
        <Modal
          view
          handleClose={handleClose}
          modalHeading={showViewSection && `View Event`}
        >
          <ViewEvent targetID={targetID} employee={employee} />
        </Modal>
      )}
    </>
  );
}

export default Events;
